module.exports = __webpack_public_path__ + "static/img/radio.b17c7811.png";